import { render, staticRenderFns } from "./sjk-detail.vue?vue&type=template&id=76840e3e&"
import script from "./sjk-detail.vue?vue&type=script&lang=ts&"
export * from "./sjk-detail.vue?vue&type=script&lang=ts&"
import style0 from "./sjk-detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports